module.exports = __webpack_public_path__ + "static/media/doctor-software-FB.d858bbae.png";